<template>
  <BasePageContainer class="page member_add">
    <div class="page__head member_add-head fixed-top p-3">
      <h1 class="member_add-head__heading">
        <router-link
          to="/admin/members/"
          class="member_add-head__back">
          <span class="material-icons">
            arrow_back_ios
          </span>
        </router-link>
        ユーザー追加
      </h1>
    </div>
    <div class="member_add__body member_add-content pt-8 pb-4">
      <form>
        <validation-observer v-slot="observer">
          <b-card
            v-for="user in users"
            :key="user.index"
            data-testid="member-add-card"
            class="card mb-2">
            <b-card-text>
              <div class="general-form__group form-group row">
                <label
                  for="team"
                  class="col-4 col-form-label">名前</label>
                <div class="col-8">
                  <validation-provider
                    v-slot="v"
                    name="名前"
                    rules="required|max:50">
                    <b-form-input
                      v-model="user.name"
                      :data-testid="`member-add-name-${user.index}`"
                      type="text" />
                    <p class="text-primary">
                      {{ v.errors[0] }}
                    </p>
                  </validation-provider>
                </div>
              </div>
              <div class="general-form__group form-group row">
                <label
                  for="team"
                  class="col-4 col-form-label">グループ</label>
                <div class="col-8">
                  <validation-provider
                    v-slot="v"
                    name="グループ"
                    rules="required">
                    <b-form-select
                      v-model="user.department"
                      :data-testid="`member-add-department-${user.index}`"
                      :options="selectDepartments" />
                    <p class="text-primary">
                      {{ v.errors[0] }}
                    </p>
                  </validation-provider>
                </div>
              </div>
              <div class="general-form__group form-group row mb-5">
                <label
                  for="email"
                  class="col-4 col-form-label">メールアドレス</label>
                <div class="col-8">
                  <validation-provider
                    v-slot="v"
                    name="メールアドレス"
                    rules="email|required">
                    <b-form-input
                      v-model="user.email"
                      :data-testid="`member-add-email-${user.index}`"
                      type="text"
                      hide-header />
                    <p class="text-primary">
                      {{ v.errors[0] }}
                    </p>
                  </validation-provider>
                </div>
              </div> 
              <p
                class="h2"
                style="position: absolute; bottom: 0px; right: 10px;"
                @click="onClickDelete(user.index)">
                <b-icon-x-circle-fill />
              </p>
            </b-card-text>
          </b-card>

          <div
            v-if="duplicatedEmails.length > 0"
            class="mt-3 d-flex justify-content-center">
            <div>
              <p class="text-primary">
                以下のメールアドレスは登録済みのため使用できません。
              </p>
              <p
                v-for="(duplicatedEmail, i) in duplicatedEmails"
                :key="i"
                class="text-primary">
                {{ duplicatedEmail }}
              </p>
            </div>
          </div>

          <div class="general-form__btn row mt-5">
            <div class="col-12">
              <p
                class="h2 icon-plus"
                @click="onClickAdd">
                <b-icon-plus-circle-fill />
              </p>
            </div>
            <div class="col-6">
              <button
                type="button"
                class="btn btn-block btn-cancel"
                @click="onClickCancel">
                キャンセル
              </button>
            </div>
            <div class="col-6">
              <button
                type="button"
                class="btn btn-block btn-primary"
                @click="observer.passes(onClickSave)">
                作成
              </button>
            </div>
          </div>
        </validation-observer>
      </form>
    </div>
  </BasePageContainer>
</template>

<script>
export default {
  data() {
    return {
      users: [{index: 1, name: '', email: '', department: null}],
      departments: [],
      index: 1,
      duplicatedEmails: []
    }
  },
  computed: {
    selectDepartments (){
      return this.departments.map(v=> {return {value: v.id, text: v.name}})
    }
  }
  ,
  mounted() {
    this.created()
  },
  methods: {
    async created() {
      this.$store.commit('startLoading')
      const departments = await this.$axios.get('/departments/?ordering=-sort_no')
        .catch(() => {
          this.$store.commit('notify/set', {isUnknownError: true, type: 'danger'})
        })
      this.departments = departments.data.results

      this.$store.commit('finishLoading')
    }, 
    onClickDelete(index){
      this.users = this.users.filter(v=> v.index!==index)
    },
    onClickAdd(){
      this.index++
      this.users.push({index: this.index, name: '', email: '', department: null})
    },
    onClickSave() {
      if (this.users.length <= 0) return
      this.duplicatedEmails = []
      this.emailDuplicationCheck()
    },
    async emailDuplicationCheck() {
      this.$store.commit('startLoading')
      const emailValidationMethods = this.users.map(user => {
        const param = {
          email: user.email
        }
        return this.$axios.post('/auth/registration/validate_email/', param)
      })
      const results = await Promise.allSettled(emailValidationMethods)
      const rejectedResults = results.filter(r => r.status === 'rejected')
      // 特にエラーがなければ、ユーザー登録処理へ
      if (rejectedResults.length === 0) {
        this.registerUsers()
        return
      }
      
      const unknownErrors = rejectedResults.filter(r => {
        if (!r.reason.response || !r.reason.response.data) return true
        return false
      })
      if (unknownErrors.length > 0) {
        this.$store.commit('notify/set', {isUnknownError: true, type: 'danger'})
        this.$store.commit('finishLoading')
        return
      }

      const emailErrors = rejectedResults.filter(r => {
        return !!r.reason.response.data.email
      })
      if (emailErrors.length === 0) {
        this.$store.commit('finishLoading')
        return
      }
      
      this.duplicatedEmails = emailErrors.map(item => {
        // config.dataにあるemailはJSONなので一度parseしないと重複したemailを取得できない
        const parsedConfigData = JSON.parse(item.reason.config.data)
        return parsedConfigData.email
      })
      this.$store.commit('finishLoading')
    },
    async registerUsers() {
      const methods = this.users.map(user =>{
        const param ={
          email: user.email,
          department: user.department,
          name: user.name
        }
        return this.$axios.post('/auth/registration/staff/', param)
      })
      await Promise.all(methods)
        .then(()=> {
          this.$store.commit('notify/set', {message: 'ユーザーの作成が完了しました。各ユーザーにパスワード設定メールが送信されます。'})
        })
        .catch(e=> {
          console.error(e)
          this.$store.commit('notify/set', {type: 'danger', message: '一部のユーザーの作成に失敗しました。ユーザー管理からユーザーを確認してください。'})
        })
      this.$store.commit('finishLoading')
      this.$router.push('/admin/members/')
    },
    onClickCancel(){
      this.$router.push('/admin/members/')
    },
  }

}
</script>

<style lang="scss" scoped>
.member_add-head{
  background-color: $l-blue;
  @media screen and (min-width:992px) {
    right: 0;
    left: 120px;
  }
  &__back{
    height: 22px;
    width: auto;
    color: $white;
    display: inline-block;
    vertical-align: text-bottom;
  }
  &__heading{
    color: $white;
    font-size: $fs-lg;
    font-weight: bold;
  }
}

.member_add{
  &__head{
    background-color: $primary;
    color: $white;
    border-radius: 8px;
  }
  &__img{
    object-fit: cover; 
    width: 60px;
    height: 60px;
    max-width: 60px;
    
  }
  &__name{
    font-weight: bold;
  }
  &__title{
    font-size: $fs-s;
    line-height: 150%;
    font-weight: bold;
  }
  &__team{
    font-size: $fs-s;
    line-height: 150%;
    font-weight: bold;
  }
}

.form-info{
  color: $grey09;
  &__logout{
    text-decoration: none;
    font-weight: bold;
    color: $grey09;
    font-size: $fs-m;
  }
  &__date{
    font-size: $fs-m;
  }
}
.card{
  background-color: $grey15;
}

.icon-plus{
  text-align: right;
}
</style>